export default function otherToggle() {
  const input = $('.js-other-toggle');
  input.on('change', function () {
    const currentValue = $(this).val();
    const elementToToggle = $($(this).data('other'));

    if (!elementToToggle.length) {
      return;
    }

    if (currentValue === 'others') {
      elementToToggle.show().find('input').prop({ disabled: false });
      $(elementToToggle).find('input').trigger('change');
    } else {
      elementToToggle.hide().find('input').prop({ disabled: true });
    }
  });
  if(input.val()) {
    input.trigger('change');
  }
}
